<template>
  <div id="root">
    {{  datum }}
  </div>
</template>

<script>

export default {
  data() {
    return {
        datum: 'LOADING'
    };
  },
  created() {
    this.loaddata();
  },
  methods: {
    loaddata() {
      this.datum = require(`@/assets/analytics/${this.$route.params.revsiteid}/${this.$route.params.dataid}_dump.json`);
        
    }
  }
};
</script>
